import { render, staticRenderFns } from "./LocalityCombobox.vue?vue&type=template&id=4d98351f&scoped=true&"
import script from "./LocalityCombobox.vue?vue&type=script&lang=js&"
export * from "./LocalityCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98351f",
  null
  
)

export default component.exports